import React from "react";
import { Nav } from "react-bootstrap";

const PhoenixNav = ({ navItems }) => {
  return (
    <Nav variant="phoenix-pills" className="mb-5 d-sm-none d-xl-flex">
      {navItems.map((item) => {
        const { label, ...rest } = item;
        return (
          <Nav.Item key={item.eventKey}>
            <Nav.Link {...rest}>{label}</Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  );
};

export default PhoenixNav;
